'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
exports['default'] = /*@ngInject*/scSelectPaginator;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

function scSelectPaginator() {

  return {
    restrict: 'E',
    require: ['?^scSelect', '^uiSelect'],
    template: '\n        <div\n          ng-show="vm.scSelectCtrl.loading"\n          style="padding: 10px"\n          class="text-center">\n          <i class="fa fa-spin fa-spinner"></i> <b>Loading...</b>\n        </div>\n        <div\n          ng-style="{padding: vm.scSelectCtrl.multiple ? \'10px\' : \'10px 0\'}"\n          ng-if="vm.scSelectCtrl && vm.scSelectCtrl.pageLimit"\n          ng-show="vm.scSelectCtrl.items.length > 0">\n          <div class="btn-group">\n            <button\n             class="btn btn-default btn-xs"\n             ng-click="vm.scSelectCtrl.changePage(vm.scSelectCtrl.currentPage - 1)"\n             ng-disabled="vm.scSelectCtrl.currentPage <= 1">\n              <i class="fa fa-arrow-left"></i> Prev\n            </button>\n            <button\n            class="btn btn-default btn-xs"\n            ng-click="vm.scSelectCtrl.changePage(vm.scSelectCtrl.currentPage + 1)"\n            ng-disabled="vm.scSelectCtrl.currentPage >= (vm.scSelectCtrl.totalItems / vm.scSelectCtrl.pageLimit)">\n              Next <i class="fa fa-arrow-right"></i>\n            </button>\n          </div>\n          <small class="pull-right">\n            {{ (vm.scSelectCtrl.currentPage - 1) * vm.scSelectCtrl.pageLimit + 1 }} -\n            {{ vm.scSelectCtrl.currentPage * vm.scSelectCtrl.pageLimit > vm.scSelectCtrl.totalItems ? vm.scSelectCtrl.totalItems : vm.scSelectCtrl.currentPage * vm.scSelectCtrl.pageLimit }} of\n            {{ vm.scSelectCtrl.totalItems }} results\n           </small>\n        </div>\n      ',
    scope: {},
    bindToController: true,
    controller: _angular2['default'].noop,
    controllerAs: 'vm',
    link: function link(scope, elm, attrs, ctrls) {
      if (ctrls[0]) {
        scope.vm.scSelectCtrl = ctrls[0];
        ctrls[0].uiSelectCtrl = ctrls[1];
      }
    }
  };
}

module.exports = exports['default'];


/** WEBPACK FOOTER **
 ** ./src/directives/scSelectPaginator.js
 **/